import React from "react";
import { Box, TextField, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { useEvent } from "../../contexts/EventContext";

function SearchFilter() {
    const {
        searchText,
        eventType,
        program,
        handleSearchChange,
        handleFilterChange,
    } = useEvent();

    return (
        <Box sx={{
            display: "flex",
            justifyContent: "space-between",
            paddingBottom: "16px",
            gap: '20px',
            backgroundColor: 'rgb(28, 28, 28, 0.9)',
            padding: 1.5,
            borderRadius: 0.5,
            marginBottom: 1
        }}>
            {/* Search Input */}
            <TextField
                label="Suche nach Events"
                variant="outlined"
                size="small"
                value={searchText}
                onChange={handleSearchChange}
                sx={{ width: "48%" }}
            />

            {/* Event Type Filter */}
            <FormControl size="small" sx={{ width: "48%" }}>
                <InputLabel>Art der Veranstaltung</InputLabel>
                <Select
                    label="Art der Veranstaltung"
                    name="eventType"
                    value={eventType}
                    onChange={handleFilterChange}
                >
                    <MenuItem value="">All</MenuItem>
                    <MenuItem value="Podiumsdiskussion">Podiumsdiskussion</MenuItem>
                    <MenuItem value="Produktpräsentation">Produktpräsentation</MenuItem>
                    <MenuItem value="Vortrag">Vortrag</MenuItem>
                    <MenuItem value="Webinar/Stream">Webinar/Stream</MenuItem>
                    <MenuItem value="Interview">Interview</MenuItem>
                    <MenuItem value="Presseveranstaltung">Presseveranstaltung</MenuItem>
                </Select>
            </FormControl>

            {/* Program Filter */}
            <FormControl size="small" sx={{ width: "48%" }}>
                <InputLabel>Programm</InputLabel>
                <Select
                    label="Programm"
                    name="program"
                    value={program}
                    onChange={handleFilterChange}
                >
                    <MenuItem value="">All</MenuItem>
                    <MenuItem value="e-nnovation SUMMIT">e-nnovation SUMMIT</MenuItem>
                    <MenuItem value="e-nnovation BRANCHENTALKS">e-nnovation BRANCHENTALKS</MenuItem>
                    <MenuItem value="e-nnovation EXPERIENCE">e-nnovation EXPERIENCE</MenuItem>
                    <MenuItem value="e-nnovation AWARDS">e-nnovation AWARDS</MenuItem>
                    <MenuItem value="e-nnovation CLUB">e-nnovation CLUB</MenuItem>
                </Select>
            </FormControl>
        </Box>
    );
}

export default SearchFilter;